import { GraphQLFieldConfig, GraphQLNonNull } from 'graphql'
import { GenericMutationResponseType } from '../types/generic-mutation-response'
import { Context } from '../shared'
import {
  entitiesMutationArgs,
  EntitiesMutationArgs
} from '../types/entities-mutation-args'
import {
  applicationFilterMutationArgs,
  ApplicationFilterMutationArgs
} from '../types/application-filter-mutation-args'
import {
  applicationsMutationResolver,
  applicationsFilterMutationResolver
} from './helpers/application'

export const restoreApplications: GraphQLFieldConfig<
  any,
  Context,
  EntitiesMutationArgs
> = {
  description: 'Restore (un-archive) applications',
  type: new GraphQLNonNull(GenericMutationResponseType),
  args: entitiesMutationArgs,
  resolve: applicationsMutationResolver('restore')
}

export const restoreApplicationsByFilters: GraphQLFieldConfig<
  any,
  Context,
  ApplicationFilterMutationArgs
> = {
  description: 'Restore (un-archive) applications by filters',
  type: new GraphQLNonNull(GenericMutationResponseType),
  args: applicationFilterMutationArgs,
  resolve: applicationsFilterMutationResolver('restore')
}
